<template>
  <!-- 修改用户名 -->
  <el-dialog title="更改账号名" :visible.sync="show" @open="open" @close="cancel" width="368px" :close-on-click-modal="false" destroy-on-close>
    <el-form :model="form" :rules="rules" ref="form" class="update-Username">
      <el-form-item prop="username">
        <el-input v-model="form.username" maxlength="20" placeholder="请输入账号名"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="cancel">取消</el-button>
      <el-button size="medium" type="primary" @click="setUsername" :loading="btnLoading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 表单验证
import { usernameVerify } from "../../../tool";
import { updateUserInfo } from "../../../api/accountManage";
import { mapActions } from "vuex";
export default {
  props: {
    updateUsername: {
      type: Boolean,
      default: false
    },
    oldUsername: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show: false,
      btnLoading: false,
      form: {
        username: null
      },
      rules: {
        username: [{ validator: usernameVerify, trigger: "blur" }]
      }
    };
  },
  watch: {
    updateUsername(val) {
      this.show = val;
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    open() {
      this.form.username = this.oldUsername;
    },
    cancel() {
      this.show = false;
      this.$emit("update:updateUsername", false);
    },
    // 修改账号名
    setUsername() {
      // 未改动时不请求接口
      if(this.form.username === this.oldUsername) {
        this.show = false;
        this.$emit("update:updateUsername", false);
        return;
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true;
          let res = await updateUserInfo(this.form).catch(() => {
            this.btnLoading = false;
          });
          if (res.code === 1) {
            this.getUserInfo();
            this.$message.success("修改账号名成功");
            this.show = false;
            this.$emit("update:updateUsername", false);
          }
          this.btnLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.update-Username {
  margin-top: 18px;
  .el-input {
    input {
      height: 48px;
    }
  }
}
</style>